module.exports = __webpack_public_path__ + "img/petstairs28.a26fb078.jpg";